import { ocApi } from './ocApi'

// ⚠️ Лучше вынести в .env.local
const API_USER = process.env.API_USER || 'testuser'
const API_PASS = process.env.API_PASS || 'testbtpeel748'

const basicAuth =
  'Basic ' + Buffer.from(`${API_USER}:${API_PASS}`).toString('base64')

const cartApi = ocApi.injectEndpoints({
  endpoints: (build) => ({
    addProductToCart: build.mutation({
      // добавить продукт в корзину
      query: (body) => {
        return {
          url: 'checkout/cart/add',
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            Authorization: basicAuth,
          },
        }
      },
      invalidatesTags: ['cart'],
    }),

    applicationCode: build.mutation({
      query: (body) => ({
        url: 'checkout/voucher/voucher',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
          Authorization: basicAuth,
        },
      }),
    }),

    applyCoupon: build.mutation({
      query: (body) => ({
        url: 'checkout/coupon/coupon',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
          Authorization: basicAuth,
        },
      }),
    }),

    getCountProducts: build.query({
      query: () => ({
        url: 'checkout/cart/getCountProducts',
        headers: { Authorization: basicAuth },
      }),
      providesTags: ['cart'],
    }),

    getPromotionsInfo: build.query({
      query: () => ({
        url: 'checkout/cart/getPromotionsInfo',
        headers: { Authorization: basicAuth },
      }),
    }),

    getCartInfo: build.query({
      query: () => ({
        url: 'd_quickcheckout/cart/indexJson',
        headers: { Authorization: basicAuth },
      }),
      providesTags: ['cart'],
    }),

    updateCartInfo: build.mutation({
      query: (data) => ({
        url: 'd_quickcheckout/cart/update',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          Authorization: basicAuth,
        },
        invalidatesTags: ['cart'],
      }),
      providesTags: ['cart'],
    }),

    getPromoStatuses: build.query({
      query: () => ({
        url: 'module/d_quickcheckout/getPromotionsStatuses',
        headers: { Authorization: basicAuth },
      }),
    }),

    getPresentsProducts: build.query({
      query: () => ({
        url: 'd_quickcheckout/product_to_present/indexJson',
        headers: { Authorization: basicAuth },
      }),
      providesTags: ['PresentToProducts'],
    }),

    updatePresentsProducts: build.mutation({
      query: (data) => ({
        url: 'd_quickcheckout/product_to_present/updateProduct',
        method: 'POST',
        body: data,
        headers: { Authorization: basicAuth },
        invalidatesTags: ['PresentToProducts'],
      }),
    }),

    clearCart: build.mutation({
      query: (userInfo) => ({
        url: 'd_quickcheckout/cart/clearCart',
        method: 'POST',
        body: { userInfo },
        headers: { Authorization: basicAuth },
        invalidatesTags: ['cart'],
      }),
    }),

    getInitialSteps: build.query({
      query: () => ({
        url: 'module/d_quickcheckout/stepsInit',
        headers: { Authorization: basicAuth },
      }),
    }),

    updateArea: build.mutation({
      query: (data) => ({
        url: 'd_quickcheckout/area/update',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          Authorization: basicAuth,
        },
      }),
    }),
  }),
})

export const {
  useAddProductToCartMutation,
  useGetCountProductsQuery,
  useGetCartInfoQuery,
  useUpdateCartInfoMutation,
  useClearCartMutation,
  useGetInitialStepsQuery,
  useUpdateAreaMutation,
  useGetPromoStatusesQuery,
  useGetPresentsProductsQuery,
  useUpdatePresentsProductsMutation,
  useGetPromotionsInfoQuery,
  useApplicationCodeMutation,
  useApplyCouponMutation,
} = cartApi

export default cartApi
